import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Tooltip,
} from "chart.js";
import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { FaCalendarAlt } from "react-icons/fa";
import styles from "./PieChart.module.css";
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const TOTAL_ROOMS = 10; // Update this if you can fetch it dynamically

const getDaysInMonth = (monthIndex, year) =>
  new Date(year, monthIndex + 1, 0).getDate();

export const OccupancyChart = ({ data, loading }) => {
  const { bookings } = data;
  const isLoading = loading?.bookings;
  const [monthlyData, setMonthlyData] = useState([]);

  useEffect(() => {
    calculateOccupancy();
  }, [bookings]);

  const calculateOccupancy = async () => {
    try {
      const currentYear = new Date().getFullYear();

      const months = [
        { label: "Jan", value: 0 },
        { label: "Feb", value: 0 },
        { label: "Mar", value: 0 },
        { label: "Apr", value: 0 },
        { label: "May", value: 0 },
        { label: "Jun", value: 0 },
        { label: "Jul", value: 0 },
        { label: "Aug", value: 0 },
        { label: "Sep", value: 0 },
        { label: "Oct", value: 0 },
        { label: "Nov", value: 0 },
        { label: "Dec", value: 0 },
      ];

      bookings?.forEach((booking) => {
        const checkIn = new Date(booking.check_in);
        const checkOut = new Date(booking.check_out);

        for (
          let date = new Date(checkIn);
          date < new Date(checkOut);
          date.setDate(date.getDate() + 1)
        ) {
          const monthIndex = date.getMonth();
          months[monthIndex].value += 1; // 1 occupied room-night
        }
      });

      const result = months.map((m, i) => {
        const totalRoomNights = getDaysInMonth(i, currentYear) * TOTAL_ROOMS;
        const occupancy = (m.value / totalRoomNights) * 100;
        return {
          month: m.label,
          value: parseFloat(occupancy.toFixed(2)),
        };
      });

      setMonthlyData(result);
    } catch (error) {
      console.error("Error fetching bookings:", error);
    }
  };

  const chartData = {
    labels: monthlyData.map((data) => data.month),
    datasets: [
      {
        label: "Occupancy (%)",
        data: monthlyData.map((data) => data.value),
        backgroundColor: "#42A5F5",
        barThickness: 12,
      },
    ],
  };

  const chartOptions = {
    maintainAspectRatio: false,
    scales: {
      y: {
        min: 0,
        max: 100,
        ticks: {
          stepSize: 25,
          callback: (value) => `${value}%`,
          padding: 1,
        },
        grid: {
          color: "#ebedef",
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  return (
    <div
      className={styles.container}
      role="region"
      aria-label="Occupancy Statistics Chart"
    >
      <div className={styles.header}>
        <h2 className={styles.title}>Occupancy Statistics</h2>
        <button className={styles.calendarButton}>
          <FaCalendarAlt className={styles.calendarIcon} />
          Monthly
        </button>
      </div>

      <div className={styles.chartContainer}>
        <Bar data={chartData} options={chartOptions} />
      </div>
    </div>
  );
};
